import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { VesselPaginationTotalsParams } from '../../../vessel/VesselOverview/useVesselPaginationTotals';
import { getAverageConsumption } from '../clients/consumptions.api';
import {
    getOrders,
    getPaginatedVessels,
    getVessel,
    getVesselProducts,
    getVesselTanksByVesselId,
} from '../clients/gateway.api';
import type { GetOrdersParams, GetPaginatedVesselsParams } from '../clients/gateway.api';
import { getReachInformation } from '../clients/reachInformation.api';
import { getConsumptionPresets, getUnmatchedVesselProducts, getVesselList } from '../clients/vessel.api';
import type { GetVesselListParams } from '../clients/vessel.api';
import { getVesselBudget } from '../clients/vesselBudgets.api';

export const vessels = createQueryKeys('vessels', {
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getVessel(id),
        contextQueries: {
            budgets: {
                queryKey: null,
                queryFn: () => getVesselBudget(id),
            },
            tanks: {
                queryKey: null,
                queryFn: () => getVesselTanksByVesselId(id),
            },
            schedulesWithPrices: {
                queryKey: null,
            },
            reachInformation: {
                queryKey: null,
                queryFn: () => getReachInformation(id),
            },
            averageConsumption: (dateFrom, dateTo, resolution) => ({
                queryKey: [dateFrom, dateTo, resolution],
                queryFn: () => getAverageConsumption({ vesselId: id, dateFrom, dateTo, resolution }),
            }),
            consumptionPresets: {
                queryKey: null,
                queryFn: () => getConsumptionPresets(id),
            },
            orders: (params: GetOrdersParams) => ({
                queryKey: [{ params }],
                queryFn: () => getOrders(params),
            }),
            products: {
                queryKey: null,
                queryFn: () => getVesselProducts(id),
            },
            unmatchedProducts: {
                queryKey: null,
                queryFn: () => getUnmatchedVesselProducts(id),
            },
        },
    }),
    list: (params: GetVesselListParams) => ({
        queryKey: [{ params }],
        queryFn: () => getVesselList(params),
    }),
    comboBoxOptions: (params: GetVesselListParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOption: (id: string) => ({
        queryKey: [id],
    }),
    pagination: (params: GetPaginatedVesselsParams) => ({
        queryKey: [{ params }],
        queryFn: () => getPaginatedVessels(params),
    }),
    totals: (params: VesselPaginationTotalsParams) => ({
        queryKey: [{ params }],
    }),
});
